import { useSession } from 'next-auth/react';
import { CustomType } from '@prisma/client';
import { fetchWithToken } from '../../helpers/fetchWithToken';
import { useQuery } from '@tanstack/react-query';

export function useTypes(campaignId: string): {
  types: CustomType[] | null;
  isLoading: boolean;
  isError: boolean;
} {
  const { data: session } = useSession();

  const query = useQuery<CustomType[]>(
    [campaignId, 'types'],
    () =>
      fetchWithToken(
        `/customTypes?campaignId=${campaignId}`,
        session?.accessToken as string,
      ),
    {
      enabled: !!session?.accessToken && !!campaignId,
      retry: false,
    },
  );

  return {
    types: query.data,
    isLoading: query.isLoading || !session?.accessToken,
    isError: query.isError,
  };
}

export function useTypesBySlug(campaignSlug: string): {
  types: CustomType[] | null;
  isLoading: boolean;
  isError: boolean;
} {
  const { data: session } = useSession();

  const query = useQuery<CustomType[]>(
    [campaignSlug, 'types'],
    () =>
      fetchWithToken(
        `/customTypes?campaignSlug=${campaignSlug}`,
        session?.accessToken as string,
      ),
    {
      enabled: !!session?.accessToken && !!campaignSlug,
      retry: false,
    },
  );

  return {
    types: query.data,
    isLoading: query.isLoading || !session?.accessToken,
    isError: query.isError,
  };
}

// export function useAddChannelMutation(campaignId: string) {
//   const { data: session } = useSession();

//   const queryClient = useQueryClient();

//   const mutation = useMutation(
//     (data: { channelName: string; campaignId: string }) =>
//       fetchWithToken('/channels/link', session?.accessToken as string, {
//         method: 'POST',
//         data: {
//           channelName: data.channelName.trim().toLowerCase(),
//           campaignId: data.campaignId,
//         },
//       }),
//     {
//       // Always refetch after error or success:
//       onSettled: () => {
//         queryClient.invalidateQueries([campaignId, 'channels']);
//       },
//     }
//   );

//   return mutation;
// }
